module.exports = __webpack_public_path__ + "img/focus.b7550657.png";